import { Box, Typography } from '@mui/material';
import NoDataIcon from '@mui/icons-material/Block';
import { NoDataComponentProps } from './types';
import styles from './noData.module.scss';

const NoDataComponent = ({ message = 'No Data Available', title }: NoDataComponentProps) => (
  <Box className={styles.noDataContainer}>
    {title ? <Typography className={styles.title}>{title}</Typography> : null}
    <NoDataIcon className={styles.icon} />
    <Typography className={styles.message}>{message}</Typography>
  </Box>
);

export default NoDataComponent;
